// removed by extract-text-webpack-plugin
module.exports = {"feetip":"feetip","place-top":"place-top","place-left":"place-left","place-bottom":"place-bottom"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/tooltip.css
// module id = 883
// module chunks = 0